import { useLoad } from "@allergy123/api-client/react";
import { Card, Status, Table, Td, Th } from "@allergy123/ui";

/** Security-relevant actions: ids and outcomes only, never content. */
export function AuditPage() {
  const data = useLoad((a) => a.admin.audit());
  return (
    <>
      <h1 className="mb-2 text-h1 font-semibold text-anchor">Audit</h1>
      <p className="mb-8 max-w-[68ch] text-ink-secondary">The most recent 200 events across the platform. Every admin mutation, enrollment, completion, attempt, and issued media link is here.</p>
      {data.state === "error" && <Status kind="error" label={`Couldn't load audit events (${data.error?.message})`} />}
      <Card>
        <Table>
          <thead>
            <tr>
              <Th>When</Th>
              <Th>Action</Th>
              <Th>Subject</Th>
              <Th>Outcome</Th>
              <Th>Actor</Th>
              <Th>Organization</Th>
            </tr>
          </thead>
          <tbody>
            {data.data?.events.length === 0 && (
              <tr>
                <Td colSpan={6} className="text-ink-secondary">
                  No events yet.
                </Td>
              </tr>
            )}
            {data.data?.events.map((e) => (
              <tr key={e.id}>
                <Td className="whitespace-nowrap">{new Date(e.at).toLocaleString()}</Td>
                <Td>{e.action}</Td>
                <Td>
                  {e.subjectType} · <span className="text-small tabular-nums">{e.subjectId.slice(0, 18)}</span>
                </Td>
                <Td>{e.outcome}</Td>
                <Td className="text-small tabular-nums">{e.actorUserId?.slice(0, 8) ?? "—"}</Td>
                <Td className="text-small tabular-nums">{e.organizationId?.slice(0, 8) ?? "—"}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
